function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

module.exports = _nonIterableRest;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@babel/runtime/helpers/nonIterableRest.js
// module id = ../node_modules/@babel/runtime/helpers/nonIterableRest.js
// module chunks = 0